import { Notification } from "@/components"

import ApiService from "@/services/Api"

import {
	Client,
	Contact
} from "@/protocols/clientCatalog"
import { IChatType } from "@/protocols/channel"
import { BaseContactsFiltersType } from "@/protocols/ClientCatalogFilterProtocol"

export const handleGetAllContactsFiltersAndCount = async (whatsappChannelId: number | undefined): Promise<BaseContactsFiltersType[]> => {
	try {
		const response = await ApiService.get(`/clients/contacts-filters/count/${whatsappChannelId}`)

		return response?.data?.filters || []
	} catch (error) {
		Notification.error({ message: "Houve um erro ao buscar os filtros" })
		return []
	}
}

export const handleGetSingleContactsFilterCount = async (conditions: BaseContactsFiltersType): Promise<number> => {
	try {
		const response = await ApiService.get(`/clients/contacts-filters/conditions/${encodeURIComponent(JSON.stringify(conditions))}/count`)

		return response.data.count
	} catch (error) {
		Notification.error({ message: "Houve um erro ao buscar os filtros" })
		return 0
	}
}

export const getPhoneContact = (client: Client | undefined): Contact | undefined => {
	const phoneContact = client?.contacts?.find((contact: Contact) => Boolean(contact?.data?.phone))

	return phoneContact
}

export const getPhoneNumber = (client: Client | undefined): string => {
	const contact = getPhoneContact(client)

	return contact?.data?.phone || ""
}

export const isLidContact = (client: Client | undefined): boolean => {
	return client?.contacts?.some(contact => contact.integration_id?.endsWith("@lid")) || false
}

export const getGroupPhoneContact = (client: Client | undefined): Contact | undefined => {
	const groupPhoneContact = client?.contacts?.find((contact: Contact) => Boolean(contact?.data?.group_phone))

	return groupPhoneContact
}

export const getGroupPhoneNumber = (client: Client | undefined): string => {
	const contact = getGroupPhoneContact(client)

	return contact?.data?.group_phone || ""
}

export const getShareLinkPhoneNumber = (client: Client | undefined, chatType: IChatType | undefined): string => {
	return chatType === "group" ? getGroupPhoneNumber(client) : getPhoneNumber(client)
}
